import fetch from "auth/FetchInterceptor";

const AuthService = {};

AuthService.login = async function (data) {
  return fetch({
    url: "/adminSchool/login",
    data: JSON.stringify(data),
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
  });
};

AuthService.registerSchoolAdmin = function (data) {
  return fetch({
    url: "/adminSchool/register",
    method: "post",
    data: data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
// call the refrech endpoint to get a new access token.
AuthService.refresh = function (data) {
  return fetch({
    url: "/auth/refresh-token",
    method: "POST",
    data,
    withCredentials: true,
  });
};
AuthService.logout = function () {
  return fetch({
    url: "/auth/logout",
    method: "POST",
    withCredentials: true,
  });
};

AuthService.getUser = function () {
  return fetch({
    url: "/adminSchool/profil",
    method: "GET",
  });
};

export default AuthService;
